<template>
    <div class="fullscreen-loading" :style="{ background }">
        <div v-if="text" class="loading-text">
            {{ text }}
        </div>

        <div class="spinner-border">
            <span class="sr-only">{{ $t('general.loading') }}</span>
        </div>

        <div v-if="total || percentage !== null" class="loading-total">
            <span v-if="total">{{ current ?? 0 }} / {{ total }}</span>
            <span v-if="percentage !== null">{{ formatPercentage(percentage) }}</span>

            <div class="download-speed" v-if="speed">{{ formatDownloadSpeed(speed) }}</div>
        </div>
    </div>
</template>

<script setup>

    import { onMounted, onUnmounted, ref, computed } from 'vue';
    import { formatDownloadSpeed, formatPercentage } from '../utils/formatNumber.js';

    const props = defineProps({
        text: {
            type: String,
            default: null,
        },

        opacity: {
            type: Number,
            default: 0.3,
        }
    });

    const total = ref(null);
    const current = ref(null);
    const percentage = ref(null);
    const speed = ref(null);

    const background = computed(() => {
        return `rgba(0, 0, 0, ${props.opacity})`;
    });

    onMounted(() => {
        window.addEventListener('download-progress', downloadProgress);
    });

    function downloadProgress(event) {
        if (event.detail.current !== undefined) {
            current.value = Math.min(event.detail.current, total.value ?? 0);
        }

        if (event.detail.total !== undefined) {
            total.value = event.detail.total;
        }

        if (event.detail.speed !== undefined) {
            speed.value = event.detail.speed;
        }

        if (event.detail.percentage !== undefined) {
            percentage.value = event.detail.percentage;
        }
    }

    onUnmounted(() => {
        window.removeEventListener('download-progress', downloadProgress);
    });

</script>

<style lang="scss" scoped>

    .fullscreen-loading {
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 500;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;;
        color: #fff;
        text-align: center;

        .loading-total,
        .loading-text {
            font-size: 20px;
            font-weight: bold;
            text-shadow: 2px 3px 12px #4d4c4c;
        }

        .loading-text {
            margin-bottom: 10px;
        }

        .loading-total {
            margin-top: 10px;
        }

        .download-speed {
            font-size: 12px;
            margin-top: -8px;
        }
    }

</style>
